import "../../../assets/css/mini.css";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Drawer, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { ArrowRight, Crown, Copy, MapPin, Store, HelpCircle } from "lucide-react";
import TopNav from "../../../components/top-nav";
import FooterDisplay from "../../../components/footer";
import ReferralSummary from "../../../components/ReferralSummary";
import ReferralHistory from "../../../components/ReferralHistory";
import ReferralModals from "../../../components/ReferralModals";
import useReferralData from "../../../hooks/useReferralData";
import { ReactComponent as HelpIcon } from "../../../assets/images/icons/help-circle.svg";
import HelpSupportButton from "../../../components/HelpSupportButton";
import { showSuccessNotification } from "../../../common/utils/notification";
import AppRoutes from "../../../common/routes";
import AmbassadorIncompleteModal from "../../../components/AmbassadorIncompleteModal";

const ReferralPage = () => {
  const navigate = useNavigate();
  const {
    dashboard,
    incomeHistory,
    incomeHistoryMeta,
    userData,
    referralPool,
    loading,
    incomeLoading,
    page,
    setPage,
    incomeTypeFilter,
    setIncomeTypeFilter,
    INCOME_TYPES,
  } = useReferralData();

  const [displaySalesAgentMessage, setDisplaySalesAgentMessage] =
    useState(false);
  const [referralMessageModal, setReferralMessageModal] = useState(false);
  const [howReferralWorkModal, setHowReferralWorkModal] = useState(false);
  const [locationModalOpen, setLocationModalOpen] = useState(false);
  const [vendorModalOpen, setVendorModalOpen] = useState(false);

  const majorSpinnerIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

  const toggleSalesAgentMessage = () =>
    setDisplaySalesAgentMessage(!displaySalesAgentMessage);
  return (
    <div className="wise9ja-content">
      <Spin indicator={majorSpinnerIcon} spinning={loading}>
        <div className="homepage wise9ja-disp h-screen">
          <div className="homepage-history-header">
            <TopNav title="Your Referral Information" />
            <div className="contain mt_5">
              {!userData?.isAmbassador && (
                <div className="mb-4 bg-white border-2 border-gray-100 rounded-2xl p-5 shadow-sm flex items-center gap-4">
                  <div className="bg-green-100 p-3 rounded-xl flex-shrink-0">
                    <span className="text-2xl">🚀</span>
                  </div>
                  <div className="text-left flex-1">
                    <h3 className=" font-extrabold text-black leading-tight">
                      Boost your earnings to 3x
                    </h3>
                    <p className="text-gray-500 ">
                      Become a Konnect Ambassador
                    </p>
                  </div>
                  <button
                    onClick={() => navigate(AppRoutes.become_ambassador)}
                    className="bg-green-600 hover:bg-green-700 text-white p-3 rounded-xl font-bold transition-all shadow-sm active:scale-95 flex-shrink-0"
                  >
                    <ArrowRight size={20} />
                  </button>
                </div>
              )}
              <ReferralSummary dashboard={dashboard} loading={loading} />

              <div className="mt-8 mb-4 text-xl border-t border-gray-100 pt-6 text-left space-y-4">
                <h4 className="font-extrabold text-sm text-red-600 tracking-wider uppercase flex items-center gap-2">
                  <span className="w-1.5 h-4 bg-red-600 rounded-full inline-block"></span>
                  Generate Referral Link
                </h4>

                <div className="grid grid-cols-2 gap-4">
                  {/* Ambassador Profile */}
                  <div
                    onClick={() => navigate(AppRoutes.become_ambassador)}
                    className="bg-white border border-gray-100 rounded-2xl p-4 cursor-pointer hover:shadow-md hover:border-green-200 transition-all duration-300 flex flex-col justify-between"
                  >
                    <div className="flex items-center justify-between mb-2">
                      <div className="bg-amber-100 text-amber-700 p-2 rounded-xl">
                        <Crown size={20} />
                      </div>
                      <ArrowRight size={16} className="text-gray-400" />
                    </div>
                    <div>
                      <h5 className="font-extrabold text-gray-900  leading-tight">
                        Ambassador Portal
                      </h5>
                      <p className="text-gray-400 text-xs mt-1">
                        View terms & stats
                      </p>
                    </div>
                  </div>

                  {/* Copy Referral Message */}
                  <div
                    onClick={() => setReferralMessageModal(true)}
                    className="bg-white border border-gray-100 rounded-2xl p-4 cursor-pointer hover:shadow-md hover:border-green-200 transition-all duration-300 flex flex-col justify-between"
                  >
                    <div className="flex items-center justify-between mb-2">
                      <div className="bg-blue-100 text-blue-700 p-2 rounded-xl">
                        <Copy size={20} />
                      </div>
                      <ArrowRight size={16} className="text-gray-400" />
                    </div>
                    <div>
                      <h5 className="font-extrabold text-gray-900  leading-tight">
                        Copy Message
                      </h5>
                      <p className="text-gray-400 text-xs mt-1">
                        Get referral link
                      </p>
                    </div>
                  </div>

                  {/* Generate by Location */}
                  <div
                    onClick={() => setLocationModalOpen(true)}
                    className="bg-red-50 border border-red-100 rounded-2xl p-4 cursor-pointer hover:shadow-md hover:border-red-350 transition-all duration-300 flex flex-col justify-between"
                  >
                    <div className="flex items-center justify-between mb-2">
                      <div className="bg-white text-red-600 p-2 rounded-xl shadow-sm">
                        <MapPin size={20} />
                      </div>
                      <ArrowRight size={16} className="text-red-500" />
                    </div>
                    <div>
                      <h5 className="font-extrabold text-red-900  leading-tight">
                        By Location
                      </h5>
                      <p className="text-red-600 text-xs mt-1 opacity-80">
                        Generate local link
                      </p>
                    </div>
                  </div>

                  {/* Generate by Vendor */}
                  <div
                    onClick={() => setVendorModalOpen(true)}
                    className="bg-red-50 border border-red-100 rounded-2xl p-4 cursor-pointer hover:shadow-md hover:border-red-355 transition-all duration-300 flex flex-col justify-between"
                  >
                    <div className="flex items-center justify-between mb-2">
                      <div className="bg-white text-red-600 p-2 rounded-xl shadow-sm">
                        <Store size={20} />
                      </div>
                      <ArrowRight size={16} className="text-red-500" />
                    </div>
                    <div>
                      <h5 className="font-extrabold text-red-900  leading-tight">
                        By Vendor
                      </h5>
                      <p className="text-red-600 text-xs mt-1 opacity-80">
                        Generate vendor link
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <button
                type="button"
                onClick={() => setHowReferralWorkModal(true)}
                className="mt-6 flex items-center gap-2 text-green-700 font-gilroyBold"
              >
                <HelpCircle size={18} />
                How Referral Works
              </button>
            </div>
          </div>
          <div className="hero-sect mt_2"></div>
          <div className="content-display-content">
            <div className="contain">
              <ReferralHistory
                referralPool={referralPool}
                incomeHistory={incomeHistory}
                incomeHistoryMeta={incomeHistoryMeta}
                incomeLoading={incomeLoading}
                loading={loading}
                incomeTypeFilter={incomeTypeFilter}
                setIncomeTypeFilter={setIncomeTypeFilter}
                INCOME_TYPES={INCOME_TYPES}
                page={page}
                setPage={setPage}
                referralCount={referralPool?.data?.length || 0}
                bonusBalance={userData?.bonusBalance ?? dashboard?.bonusBalance ?? 0}
              />
            </div>
          </div>
        </div>
      </Spin>
      <ReferralModals
        howReferralWorkModal={howReferralWorkModal}
        setHowReferralWorkModal={setHowReferralWorkModal}
        referralMessageModal={referralMessageModal}
        setReferralMessageModal={setReferralMessageModal}
        locationModalOpen={locationModalOpen}
        setLocationModalOpen={setLocationModalOpen}
        vendorModalOpen={vendorModalOpen}
        setVendorModalOpen={setVendorModalOpen}
        userData={userData}
      />
      <HelpSupportButton page="REFERRAL" />
      <FooterDisplay />
      <Drawer
        footer={null}
        onClose={toggleSalesAgentMessage}
        open={displaySalesAgentMessage}
        placement="bottom"
      >
        <div className="modal-disp empty">
          <div className="extra-detail">
            <div className="contain">
              <HelpIcon
                style={{
                  height: "4rem",
                  margin: "0px auto",
                  width: "auto",
                  display: "block",
                  marginBottom: 10,
                }}
              />
              <p>
                Sales referral pool is the cash you get when you refer food
                vendors
              </p>
              <button
                onClick={toggleSalesAgentMessage}
                style={{ display: "block", textAlign: "center" }}
                className="btn btn-red"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </Drawer>
      <AmbassadorIncompleteModal userData={userData} />
    </div>
  );
};

export default ReferralPage;
